import * as Term_bs$SolvuuLang0 from "./term_bs.bs.js";
var Json =
/* alias */
0;
var json_of_project = Term_bs$SolvuuLang0.write_project;
var json_of_scalar = Term_bs$SolvuuLang0.write_scalar;
var json_of_blob_id = Term_bs$SolvuuLang0.write_blob_id;
var json_of_uri = Term_bs$SolvuuLang0.write_uri;
var json_of_extern = Term_bs$SolvuuLang0.write_extern;
var json_of_var = Term_bs$SolvuuLang0.write_var;
var json_of_intrinsic = Term_bs$SolvuuLang0.write_intrinsic;
var json_of_app = Term_bs$SolvuuLang0.write_app;
var json_of_arrow = Term_bs$SolvuuLang0.write_arrow;
var json_of_nullable_ = Term_bs$SolvuuLang0.write_nullable_;
var json_of_list_ = Term_bs$SolvuuLang0.write_list_;
var json_of_record = Term_bs$SolvuuLang0.write_record;
var json_of_container = Term_bs$SolvuuLang0.write_container;
var json_of_ascription = Term_bs$SolvuuLang0.write_ascription;
var json_of_conditional = Term_bs$SolvuuLang0.write_conditional;
var json_of_error = Term_bs$SolvuuLang0.write_error;
var json_of_future = Term_bs$SolvuuLang0.write_future;
var json_of_meta = Term_bs$SolvuuLang0.write_meta;
var json_of_closure = Term_bs$SolvuuLang0.write_closure;
var json_of_dir = Term_bs$SolvuuLang0.write_dir;
var json_of_t = Term_bs$SolvuuLang0.write_t;
var project_of_json = Term_bs$SolvuuLang0.read_project;
var scalar_of_json = Term_bs$SolvuuLang0.read_scalar;
var blob_id_of_json = Term_bs$SolvuuLang0.read_blob_id;
var uri_of_json = Term_bs$SolvuuLang0.read_uri;
var extern_of_json = Term_bs$SolvuuLang0.read_extern;
var var_of_json = Term_bs$SolvuuLang0.read_var;
var intrinsic_of_json = Term_bs$SolvuuLang0.read_intrinsic;
var app_of_json = Term_bs$SolvuuLang0.read_app;
var arrow_of_json = Term_bs$SolvuuLang0.read_arrow;
var nullable__of_json = Term_bs$SolvuuLang0.read_nullable_;
var list__of_json = Term_bs$SolvuuLang0.read_list_;
var record_of_json = Term_bs$SolvuuLang0.read_record;
var container_of_json = Term_bs$SolvuuLang0.read_container;
var ascription_of_json = Term_bs$SolvuuLang0.read_ascription;
var conditional_of_json = Term_bs$SolvuuLang0.read_conditional;
var error_of_json = Term_bs$SolvuuLang0.read_error;
var future_of_json = Term_bs$SolvuuLang0.read_future;
var meta_of_json = Term_bs$SolvuuLang0.read_meta;
var closure_of_json = Term_bs$SolvuuLang0.read_closure;
var dir_of_json = Term_bs$SolvuuLang0.read_dir;
var t_of_json = Term_bs$SolvuuLang0.read_t;
export { Json, json_of_project, json_of_scalar, json_of_blob_id, json_of_uri, json_of_extern, json_of_var, json_of_intrinsic, json_of_app, json_of_arrow, json_of_nullable_, json_of_list_, json_of_record, json_of_container, json_of_ascription, json_of_conditional, json_of_error, json_of_future, json_of_meta, json_of_closure, json_of_dir, json_of_t, project_of_json, scalar_of_json, blob_id_of_json, uri_of_json, extern_of_json, var_of_json, intrinsic_of_json, app_of_json, arrow_of_json, nullable__of_json, list__of_json, record_of_json, container_of_json, ascription_of_json, conditional_of_json, error_of_json, future_of_json, meta_of_json, closure_of_json, dir_of_json, t_of_json };
/* No side effect */